interface ServiceBadgeProps {
  service: string;
  color?: string | null;
}

export function ServiceBadge({ service, color }: ServiceBadgeProps) {
  const baseColor = color || "#64748B";

  return (
    <span
      className="inline-block px-2.5 py-0.5 rounded text-xs font-semibold border"
      style={{
        color: baseColor,
        backgroundColor: `${baseColor}15`,
        borderColor: `${baseColor}40`,
      }}
    >
      {service}
    </span>
  );
}
